/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Apply_Now_ButtonInputs */

const en_candidate_apply_now_button = /** @type {(inputs: Candidate_Apply_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply now`)
};

const de_candidate_apply_now_button = /** @type {(inputs: Candidate_Apply_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt bewerben`)
};

/**
* | output |
* | --- |
* | "Apply now" |
*
* @param {Candidate_Apply_Now_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_apply_now_button = /** @type {((inputs?: Candidate_Apply_Now_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Apply_Now_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_apply_now_button(inputs)
	return en_candidate_apply_now_button(inputs)
});